import React from "react";
import {
  formatPlainDate,
  formatDateTime,
  daysUntilPlainDate,
} from "../../../utils/dateTime";

/** Warranty date: red when expired, amber within 30 days. */
export const WarrantyText = ({ date }) => {
  if (!date) return <span className="text-slate-400">—</span>;
  const days = daysUntilPlainDate(date);
  const tone =
    days < 0
      ? "text-danger fw-semibold"
      : days <= 30
        ? "text-amber-600 fw-semibold"
        : "";
  const title =
    days < 0
      ? "Warranty expired"
      : days <= 30
        ? `Expires in ${days} day(s)`
        : undefined;
  return (
    <span className={tone} title={title}>
      {days < 0 && <i className="bi bi-exclamation-circle me-1"></i>}
      {formatPlainDate(date)}
    </span>
  );
};

/** Expected return date of a loan, red when overdue. */
export const ExpectedReturn = ({ date }) => {
  if (!date) return <span className="text-slate-500">Permanent</span>;
  const days = daysUntilPlainDate(date);
  return days < 0 ? (
    <span className="text-danger fw-semibold">
      <i className="bi bi-alarm me-1"></i>
      {formatPlainDate(date)} (overdue)
    </span>
  ) : (
    formatPlainDate(date)
  );
};

/** "Acknowledged on …" or "Waiting for employee". */
export const AcknowledgementText = ({ acknowledgedAt }) =>
  acknowledgedAt ? (
    <span className="text-success">
      <i className="bi bi-check2-circle me-1"></i>Acknowledged on{" "}
      {formatDateTime(acknowledgedAt)}
    </span>
  ) : (
    <span className="text-amber-600">
      <i className="bi bi-hourglass-split me-1"></i>Waiting for employee
    </span>
  );

/** "₱58,500.00" */
export const peso = (n) =>
  n === null || n === undefined || n === ""
    ? "—"
    : `₱${Number(n).toLocaleString("en-PH", { minimumFractionDigits: 2 })}`;
